import React from "react";
import { ChangeEvent, FormEvent } from "react";
import { RouteComponentProps } from "react-router";

import { V2 } from "./Api";
import { IS_PRE_RELEASE } from "./version";

import { IAuthProps } from "./components/AuthContext";
import withAuth from "./components/withAuth";

import "./blocks.css";
import "./button.css";
import "./form.css";
import "./LoginPage.css";

interface IChangePasswordPageState {
    newPassword1: string;
    newPassword2: string;

    isPasswordValid: boolean;

    submitErrorMessage?: string | boolean;

    [name: string]: string | boolean | number | undefined;
}

class ChangePasswordPage extends React.Component<IAuthProps & RouteComponentProps<any>, IChangePasswordPageState> {
    constructor(props: Readonly<IAuthProps & RouteComponentProps<any>>) {
        super(props);

        this.state = {
            newPassword1: "",
            newPassword2: "",

            isPasswordValid: false,
        };

        this.formInputChanged = this.formInputChanged.bind(this);
        this.doPasswordChange = this.doPasswordChange.bind(this);
        this.logout = this.logout.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<IAuthProps & RouteComponentProps<any>>, prevState: Readonly<IChangePasswordPageState>) {
        if (prevState.newPassword1 !== this.state.newPassword1 ||
            prevState.newPassword2 !== this.state.newPassword2) {

            const isPasswordValid =
                (!!this.state.newPassword1 && this.state.newPassword1.length >= 7) &&
                (!!this.state.newPassword2 && this.state.newPassword2.length >= 7);

            this.setState({
                isPasswordValid
            });
        }
    }

    public render() {
        return (
            <div className="login-root">
                {
                    IS_PRE_RELEASE
                        ? <div className="beta-notice beta-notice-absolute print-hide">
                            <span>This is pre-release software.  You may encounter bugs or unfinished features.</span>
                        </div>
                        : ""
                }
                <form className="login-box input-form info-block-primary" onSubmit={this.doPasswordChange}>
                    <section className="info-block">
                        <header>
                            <h3>Change Password</h3>
                        </header>

                        <p>For security, your password must be changed before you can continue.</p>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-dialog-new-password-1">New Password</label>
                                <input type="password" id="frm-dialog-new-password-1" name="newPassword1" value={this.state.newPassword1} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                            </div>
                        </section>

                        <small><em>Enter your new password a second time to makre sure you get it right.</em></small>
                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-dialog-new-password-2">Confirm Password</label>
                                <input type="password" id="frm-dialog-new-password-2" name="newPassword2" value={this.state.newPassword2} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                            </div>
                        </section>
                        <p className="small-text">After changing your password, you will be sent back to the login page.  Log in using your new password.</p>
                        {
                            this.state.submitErrorMessage === true
                                ? <div className="spinner lds-dual-ring" />
                                : this.state.submitErrorMessage
                                    ? <div className="error-box">{this.state.submitErrorMessage}</div>
                                    : ""
                        }
                        <div className="action-panel-dialog">
                            <button type="submit" className="button push-right text-with-icon" disabled={!this.state.isPasswordValid || this.state.submitErrorMessage === true}><i className="icon-lock" /><span>Change Password</span></button>
                            <button type="button" className="button" onClick={this.logout}>Cancel</button>
                        </div>
                    </section>
                </form>
            </div>
        );
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    private async doPasswordChange(e: FormEvent) {
        e.preventDefault();
        if (!this.state.newPassword1 || !this.state.newPassword2) {
            return;
        }

        if (this.state.newPassword1 !== this.state.newPassword2) {
            this.setState({
                submitErrorMessage: "New passwords must match"
            });
            return;
        }

        try {
            this.setState({
                submitErrorMessage: true,
            });

            const passwordRequest = {
                newPassword: this.state.newPassword1
            };

            await V2.post("auth/set_initial_password", passwordRequest);

            // Clear login info
            await this.props.authContext.logoutUser();
        }
        catch (e) {
            this.setState({
                submitErrorMessage: e.message
            });
        }
    }

    private async logout() {
        await this.props.authContext.logoutUser();
    }
}

export default withAuth(ChangePasswordPage);
